module.exports = __webpack_public_path__ + "static/media/cloneterest-screenshot-2.dfe64d77.jpg";